/** /design: the overview of the current direction. */
import { createFileRoute } from '@tanstack/react-router';
import { DesignOverviewRoute } from '../../design/route-parts.js';

export const Route = createFileRoute('/design/')({
  component: DesignOverviewRoute,
});
